import Integrations from './Integrations.container';

export default Integrations;
